module.exports = __webpack_public_path__ + "img/con2_keyword_bg.6463cf72.png";